import { useQuery } from "@tanstack/react-query";
import { getProgress, getVideo } from "@/services/videoService";

/** Video sources are resolved lazily (only on the Watch page). */
export const useVideo = (id, episode, enabled = true) =>
  useQuery({ queryKey: ["video", id, episode || ""], queryFn: ({ signal }) => getVideo(id, { episode, signal }), enabled: Boolean(id) && enabled, staleTime: 5 * 60 * 1000, retry: 1 });

export const useProgress = (id, enabled) =>
  useQuery({ queryKey: ["progress", id], queryFn: () => getProgress(id), enabled: Boolean(id) && enabled, staleTime: 0, retry: 0 });
